import { HeroLayout } from '@primer/gatsby-theme-doctocat';
import React from 'react';
export default {
  HeroLayout,
  React
};